import * as React from 'react';

type FormPostElement = React.ElementRef<'form'>;
type FormPostProps = Omit<React.ComponentPropsWithoutRef<'form'>, 'method'>;

// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
const FormPost = React.forwardRef<FormPostElement, FormPostProps>(
  (props, forwardedRef) => {
    return <form {...props} method="post" ref={forwardedRef} />;
  },
);

FormPost.displayName = 'FormPost';

export { FormPost };
